import { render, staticRenderFns } from "./Renyuandaishenhe.vue?vue&type=template&id=1262d70a&scoped=true"
import script from "./Renyuandaishenhe.vue?vue&type=script&lang=js"
export * from "./Renyuandaishenhe.vue?vue&type=script&lang=js"
import style0 from "./Renyuandaishenhe.vue?vue&type=style&index=0&id=1262d70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1262d70a",
  null
  
)

export default component.exports